module.exports = __webpack_public_path__ + "media/images/logo/test-4500bbf8425087a221b422f5a976f250.png";